var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoiPphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-VOIP_phone"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VOIP_phone",
    "data-name": "VOIP phone",
    clipPath: "url(#clip-VOIP_phone)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DTMF_phone",
    "data-name": "DTMF phone",
    d: "M428.194,481.77H39.973C19.546,481.77,3,468.28,3,451.659V90.332C3,73.7,19.546,60.221,39.973,60.221V421.549c0,16.621,16.564,30.111,36.973,30.111h73.947c20.428,0,36.973-13.49,36.973-30.111V60.221H428.194c20.428,0,36.973,13.49,36.973,30.111V451.659C465.167,468.28,448.622,481.77,428.194,481.77ZM335.76,436.6h36.973V406.493H335.76Zm0-45.166h36.973V361.328H335.76Zm0-45.166h36.973V316.162H335.76Zm0-45.166h36.973V271H335.76ZM280.3,436.6h36.973V406.493H280.3Zm0-45.166h36.973V361.328H280.3Zm0-45.166h36.973V316.162H280.3Zm0-45.166h36.973V271H280.3ZM428.194,105.387c0-8.326-8.264-15.055-18.487-15.055H243.327c-10.2,0-18.487,6.73-18.487,15.055v60.221c0,8.311,8.282,15.055,18.487,15.055h166.38c10.223,0,18.487-6.745,18.487-15.055Zm0,165.608H391.22v30.111h36.973Zm0,45.166H391.22v30.111h36.973Zm0,45.166H391.22v30.111h36.973Zm0,45.166H391.22V436.6h36.973ZM150.893,436.6H76.947c-10.2,0-18.487-6.73-18.487-15.055V45.166c0-8.326,8.282-15.055,18.487-15.055h35.827V0h19.633V30.111h18.487c10.2,0,18.487,6.73,18.487,15.055V421.549C169.38,429.874,161.1,436.6,150.893,436.6Z",
    transform: "translate(18.597 13.865)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiPphone);
export default __webpack_public_path__ + "static/media/VOIP phone.1dd0720c3decdef102f31e6e4271be80.svg";
export { ForwardRef as ReactComponent };